<script setup lang="ts">
import { ref } from 'vue'

import { getClasses } from '~/js/composables/classes'

interface Props {
    color?: string|null,
    utilities?: string
}

withDefaults(defineProps<Props>(), {
    color: null,
    utilities: ''
})

const classes = ref({
    _default: {
        color: 'text-neutral-900 dark:text-white',
        font: 'font-primary font-semibold leading-tight',
        size: 'text-xl md:text-2xl',
    }
})
</script>

<template>
    <span :class="[
        getClasses(classes, '_default'), 
        color,
        utilities, 
    ]">
        <slot></slot>
    </span>
</template>